document.addEventListener('DOMContentLoaded', function() {

  // Basis swiper + mogelijk lightgallery 
  
  document.querySelectorAll('.block-featured-projects').forEach(carousel => {
    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    const swiperId = carousel.id;

    const swiper = new Swiper(carousel.querySelector('.swiper-container'), {
      spaceBetween: 0,
      slidesPerView: 1,
      autoplay: {
          delay: 1000,
          disableOnInteraction: false,
      },
      speed: 3000, // Set transition speed to 2 seconds
      loop: true,
      navigation: false,
      breakpoints: {
        576: {
          spaceBetween: 30,
          speed: 3000, // Set transition speed to 2 seconds
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      }
    });

  });

});